import { useEffect, useRef } from "react";

// Tries to autoplay with sound; if the browser blocks it, retries muted so the video always starts.
export function useVideoAutoplay(key, enabled = true) {
  const ref = useRef(null);

  useEffect(() => {
    const v = ref.current;
    if (!v || !enabled) return;
    const attempt = v.play();
    if (attempt && typeof attempt.catch === "function") {
      attempt.catch(() => {
        v.muted = true;
        v.play().catch(() => {});
      });
    }
  }, [key, enabled]);

  return ref;
}
